import Box, { BoxProps } from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio, { RadioProps } from "@mui/material/Radio";
import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import { Typography } from "../Typography/Typography";
import { Option } from "../types";

interface Props<T> extends Omit<BoxProps, "onChange" | "value"> {
  label: string;
  value?: T;
  onChange: (value: T) => void;
  options: Option<T>[];
  radioGroupProps?: RadioGroupProps;
  radioProps?: RadioProps;
}

export const RadioButtons = <T,>(props: Props<T>) => {
  const {
    label,
    value,
    options,
    onChange,
    radioGroupProps,
    radioProps,
    ...rest
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const option = event.target as HTMLInputElement;
    if (!option.disabled) {
      onChange(option.value as T);
    }
  };

  return (
    <Box {...rest}>
      {label && <Typography variant="titleSmall">{label}</Typography>}
      <RadioGroup value={value} onChange={handleChange} {...radioGroupProps}>
        {options.map((option) => (
          <FormControlLabel
            key={`$${option.value}`}
            value={option.value}
            control={<Radio {...radioProps} />}
            label={option.label}
            disabled={option.disabled}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
